const state = {
    pos: 0,
    legdz: false,
    legtz: false

}
const getters = {
    pos(state) {
        return state.pos
    },
    legdz(state) {
        return state.legdz
    },
    legtz(state) {
        return state.legtz
    },

}
const mutations = {
    changepos(state, pos) {
        state.pos = pos
    },
    changelegdz(state, legdz) {
        state.legdz = legdz
    },
    changelegtz(state, legtz) {
        state.legtz = legtz
    }

}
const actions = {
    changepos({
        commit
    }, num) {
        commit('changepos', num)
    },
    changelegdz({
        commit
    }, num) {
        commit('changelegdz', num)
    },
    changelegtz({
        commit
    }, num) {
        commit('changelegtz', num)
    },

}
export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}